var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagramIcn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 19.01 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #030e1f;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18.94,5.58h0c-.07-1.52-.42-2.87-1.54-3.98S14.94.14,13.41.06c-1.56-.09-6.27-.09-7.83,0-1.52.07-2.87.42-3.98,1.53C.48,2.71.14,4.06.07,5.58-.02,7.14-.02,11.85.07,13.41c.07,1.52.42,2.87,1.54,3.98,1.11,1.11,2.46,1.46,3.98,1.54,1.57.09,6.27.09,7.84,0,1.52-.07,2.87-.42,3.98-1.54s1.46-2.46,1.54-3.98c.09-1.57.09-6.27,0-7.83ZM16.91,15.1c-.33.82-.98,1.48-1.81,1.81-1.25.49-4.22.38-5.6.38s-4.35.11-5.6-.38c-.82-.33-1.48-.98-1.81-1.81-.49-1.25-.38-4.22-.38-5.6s-.11-4.35.38-5.6c.33-.82.98-1.48,1.81-1.81,1.25-.49,4.22-.38,5.6-.38s4.35-.11,5.6.38c.82.33,1.48.98,1.81,1.81.49,1.25.38,4.22.38,5.6s.11,4.35-.38,5.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M14.57,3.29c-.63,0-1.14.51-1.14,1.14s.51,1.14,1.14,1.14,1.14-.51,1.14-1.14-.51-1.14-1.14-1.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M9.5,4.63c-2.7,0-4.87,2.17-4.87,4.87s2.17,4.87,4.87,4.87,4.87-2.17,4.87-4.87-2.17-4.87-4.87-4.87ZM9.5,12.66c-1.74,0-3.17-1.42-3.17-3.17s1.42-3.17,3.17-3.17,3.17,1.42,3.17,3.17-1.42,3.17-3.17,3.17Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramIcn);
export default __webpack_public_path__ + "static/media/instagram-icn.c3804944a40058597e4c290c533f563f.svg";
export { ForwardRef as ReactComponent };